/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import router from '@/router/index';
import store from '@/store/index';
import * as types from '@/store/types';
import { httpClient, UNAUTHORIZED } from './httpClient';

// Added the customer interceptors to check the response before they are handled by then or catch
httpClient.interceptors.response.use((response) => response, (err) => {
  if ((err.response
    && err.response.status
    && err.response.status === UNAUTHORIZED)
    && (router.currentRoute.meta
    && router.currentRoute.meta.requiresAuth)) {
    store.dispatch(`user/${types.REMOVE_USER_STATE}`);

    router.push('/login');
  }
  return Promise.reject(err);
});
